export default class BulkOperation {
  folder;
  entryIdsArr;

  constructor (folder, entryIdsArr) {
    this.folder = folder;
    this.entryIdsArr = entryIdsArr;
  }
}
